import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {Store} from '@ngrx/store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-create-support-ticket',
  templateUrl: './create-support-ticket.component.html',
  styleUrls: ['./create-support-ticket.component.css']
})
export class CreateSupportTicketComponent implements OnInit, OnDestroy {

  supportTicketForm: any;
  supportTicketFormErrors: any;
  unSubscribe$ = new Subject<void>();
  result: any;

  constructor(public dialogRef: MatDialogRef<CreateSupportTicketComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>) {
    this.supportTicketFormErrors = {
      title: {},
      description: {}
    };
    this.result = {
      supportTicket: null,
      save: false
    };
  }

  ngOnInit() {
    this.supportTicketForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required]
    });

    this.supportTicketForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.supportTicketFormErrors) {
      if (!this.supportTicketFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.supportTicketFormErrors[field] = {};
      const control = this.supportTicketForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.supportTicketFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.supportTicketForm.valid) {
      this.supportTicketForm.controls['title'].setValue(this.supportTicketForm.controls['title'].value.trim());
      this.supportTicketForm.controls['description'].setValue(this.supportTicketForm.controls['description'].value.trim());

      const supportTicket = {
        title: this.supportTicketForm.value.title,
        description: this.supportTicketForm.value.description
      };

      this.result.save = true;
      this.result.supportTicket = supportTicket;
    }
  }
}
